import { render, staticRenderFns } from "./DataUpdater.vue?vue&type=template&id=388fc27e&scoped=true"
import script from "./DataUpdater.vue?vue&type=script&lang=js"
export * from "./DataUpdater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388fc27e",
  null
  
)

export default component.exports